import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subject} from "rxjs";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {NgForm} from "@angular/forms";

@Component({
  selector: 'app-archive-reports',
  templateUrl: './archive-reports-modal.component.html',
  styleUrls: ['./archive-reports-modal.component.scss']
})
export class ArchiveReportsModalComponent implements OnInit, OnDestroy {

  subject: Subject<number>;
  subscription: any;
  noOfDays: number = null;
  @ViewChild('f') form: NgForm;

  constructor(public bsModalRef: BsModalRef,
              private modalService: BsModalService,) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc')
        this.onCancel();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(null);
    this.subject.complete();
  }

  onConfirm(): void {
    this.bsModalRef.hide();
    this.subject.next(this.noOfDays);
    this.subject.complete();
  }

}
